import * as DashboardConstants from '.././DashboardConstants';

export const resourceUtilizationHeaders = [
    {
        key: 'resource',
        header: DashboardConstants.ResourceName
    },
    {
        key: 'utilization',
        header: DashboardConstants.Utilization
    }
];

export const automataOnboardingHeadersUll = [
    {
        key: 'automataName',
        header: DashboardConstants.AutomataNames
    },
    {
        key: 'botId',
        header: DashboardConstants.BotId
    },
    {
        key: 'model',
        header: DashboardConstants.DeploymentModel
    },
    {
        key: 'onBoardingDate',
        header: DashboardConstants.OnboardingDate
    },
    {
        key: 'offBoardingDate',
        header: DashboardConstants.OffboardingDate
    },
    {
        key: 'status',
        header: DashboardConstants.Status
    },
    {
        key: 'technology',
        header: DashboardConstants.Technology
    },
    {
        key: 'executions',
        header: DashboardConstants.Executions
    }
];

export const automataOnboardingHeaders = [
    {
        key: 'automataName',
        header: DashboardConstants.AutomataNames
    },
    {
        key: 'model',
        header: DashboardConstants.DeploymentModel
    },
    {
        key: 'onBoardingDate',
        header: DashboardConstants.OnboardingDate
    },
    {
        key: 'offBoardingDate',
        header: DashboardConstants.OffboardingDate
    },
    {
        key: 'status',
        header: DashboardConstants.Status
    },
    {
        key: 'executions',
        header: DashboardConstants.Executions
    }
];
